import YTPlayer from '../../scripts/components/YTPlayer';

export function initNewsroomArticleYtPlayer(actionSelector) {
  return YTPlayer.init(
    '#article-newsroom-ytplayer',
    '#article-newsroom-ytplayer__frame',
    actionSelector
  );
}
